const BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

function authenticatedHeaders(options) {
  const token = localStorage.getItem("token");
  return {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function parseResponse(res) {
  const contentType = res.headers.get("content-type") || "";
  return contentType.includes("application/json")
    ? res.json()
    : res.text();
}

function apiError(data, status) {
  const message =
    (data && data.error) ||
    (data && data.message) ||
    (typeof data === "string" && data) ||
    `HTTP ${status}`;
  const err = new Error(message);
  err.status = status;
  err.data = data;
  return err;
}

export async function apiFetch(url, options = {}) {
  const headers = authenticatedHeaders(options);

  // only set JSON content-type when sending a body
  const isFormData = options.body instanceof FormData;

  if (!isFormData && options.body && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  // fire request
  const res = await fetch(`${BASE_URL}${url}`, {
    ...options,
    headers,
  });

  // handle "no content" cases safely (204, etc.)
  if (res.status === 204) return null;

  const data = await parseResponse(res);

  // throw descriptive errors on failure
  if (!res.ok) {
    throw apiError(data, res.status);
  }

  return data;
}

/**
 * Fetches a binary API response with the same bearer authentication used by
 * JSON requests. Error responses are still parsed into the application's
 * standard Error shape so callers can show useful feedback.
 */
export async function apiFetchBlob(url, options = {}) {
  const headers = authenticatedHeaders(options);

  const res = await fetch(`${BASE_URL}${url}`, {
    ...options,
    headers,
  });

  if (!res.ok) {
    throw apiError(await parseResponse(res), res.status);
  }

  return res.blob();
}
